import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';

import { MutualModule } from '@shared/mutual/mutual.module';
import {
  CardDefaultComponent,
  CardFormDefaultComponent,
  CardPaymentComponent,
  MobileDataCardComponent,
  MobileDataEmptyComponent,
  MobileDataWrapperCardComponent,
} from './components';
import { CardApplyCouponComponent } from './components/card-apply-coupon/card-apply-coupon.component';

@NgModule({
  declarations: [
    CardFormDefaultComponent,
    CardDefaultComponent,
    CardPaymentComponent,
    CardApplyCouponComponent,
    MobileDataWrapperCardComponent,
    MobileDataCardComponent,
    MobileDataEmptyComponent,
  ],
  imports: [CommonModule, TranslateModule, MutualModule, FlexLayoutModule],
  exports: [
    CardFormDefaultComponent,
    CardDefaultComponent,
    CardPaymentComponent,
    CardApplyCouponComponent,
    MobileDataWrapperCardComponent,
    MobileDataCardComponent,
    MobileDataEmptyComponent,
  ],
})
export class CardsModule {}
